<template>
  <v-app-bar app clipped-left color="blue" dark>
    <v-toolbar-title class="headline text-uppercase white--text">
    <router-link to="/">          
      <v-btn dark icon>
              <v-icon>{{ icon }}</v-icon>
       </v-btn>
    </router-link>
     <span>Pivot<sub>3</sub><sup>B</sup><sup class="text-lowercase">eta</sup></span>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <router-link :to=editorLink>
      <v-btn v-if="shouldRender" text target="_blank">
        <span class="mr-2">{{editorText}}</span>
      </v-btn>
    </router-link>
    <!-- <router-link to="/about">
      <v-btn text target="_blank">
        <span class="mr-2">About</span>
      </v-btn>
    </router-link> -->
    <login @logger="renderEditorButton"/>
  </v-app-bar>
</template>

<script>
import login from "../views/Login"
export default {

  name: "Header",
  components:{
    login
  },
  methods:{
    renderEditorButton(){
     // this.shouldRender = this.$store.state.currentUser != null;
    }
  },
  computed:{
    editorText(){
      if(  this.$store.state.currentUser != null && this.$store.state.userProfile.editorEnabled === true){
          return "Editor"
      }
      else{
        return "Try Me"
      }
    },
    editorLink(){
      if(  this.$store.state.currentUser != null && this.$store.state.userProfile.editorEnabled === true){
          return "/editor"
      }
      else{
        return "/tryme"
      }
    },
    shouldRender(){
      return true;//this.$store.state.currentUser != null && this.$store.state.userProfile.editorEnabled === true;
    }
  },
  data(){
    return {
      icon:'fas fa-infinity',
    //  shouldRender: false
    }
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
